<template>
  <v-card>
    <div v-if="shouldDisplayResponseCardTitle">
      <v-card-title
        v-if="responseCard.title && responseCard.title.trim()"
        primary-title
        class="red lighten-5"
      >
        <span class="headline">{{ responseCard.title }}</span>
      </v-card-title>
    </div>
    <v-card-text v-if="responseCard.subTitle">
      <span>{{ responseCard.subTitle }}</span>
    </v-card-text>
    <v-card-media
      v-if="responseCard.imageUrl"
      v-bind:src="responseCard.imageUrl"
      contain
      height="33vh"
    ></v-card-media>
    <v-card-actions v-if="responseCard.buttons" class="button-row">
      <!-- v-bind:disabled="shouldDisableClickedResponseCardButtons" -->
      <ul
        v-for="(button, id) in responseCard.buttons"
        v-show="button.text && button.value"
        v-bind:key="id"
        v-on:click="onButtonClick(button.value)"
        class="secondarybtn"
      >
        <li
          :style="{ 'font-size': '4vw', marginLeft: '6vw', color: '#C1C1C1' }"
        >
          <div class="buttonContainer">
            <div> {{ button.text }} </div>
          </div>
        </li>
      </ul>
    </v-card-actions>
    <v-card-actions v-if="responseCard.attachmentLinkUrl">
      <v-btn
        flat
        class="red lighten-5"
        tag="a"
        v-bind:href="responseCard.attachmentLinkUrl"
        target="_blank"
      >
        Open Link
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
export default {
  name: "response-card",
  props: ["response-card"],
  data() {
    return {
      network: true,
      hasButtonBeenClicked: false,
    };
  },
  computed: {
    shouldDisplayResponseCardTitle() {
      return this.$store.state.config.ui.shouldDisplayResponseCardTitle;
    },
    shouldDisableClickedResponseCardButtons() {
      return (
        this.$store.state.config.ui.shouldDisableClickedResponseCardButtons &&
        (this.hasButtonBeenClicked || this.getRCButtonsDisabled())
      );
    },
  },
  mounted() {
    window.addEventListener("online", this.update), // 网络由异常到正常时触发
    window.addEventListener("offline", this.update); //网络由正常到异常时触发
  },
  beforeDestroy() {
    window.removeEventListener("online", this.update);
    window.removeEventListener("offline", this.update);
  },
  inject: ["getRCButtonsDisabled", "setRCButtonsDisabled"],
  methods: {
    update(res) {
      console.log("update--", res);
      this.network = res.type === "online";
      if (this.network) {
        console.log("response网络正常");
      } else {
        console.log("response网络异常");
      }
    },
    onButtonClick(value) {
      if (this.network === false) {
        // toast({ text: this.$t("licence.key_internet_error"), time: 1000 });
        if (window.webkit != undefined) {
          let text = this.$t("licence.key_internet_error");
          window.webkit.messageHandlers.showToast.postMessage(text);
        } else {
          let text = this.$t("licence.key_internet_error");
          feedback.showToast(text);
        }
      } else {
        this.hasButtonBeenClicked = true;
        this.setRCButtonsDisabled();
        const messageType = this.$store.state.config.ui.hideButtonMessageBubble
          ? "button"
          : "human";
        const message = {
          type: messageType,
          text: value,
        };

        this.$store.dispatch("postTextMessage", message);
      }
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Poppins-SemiBold";
  src: url("../assets/fonts/Poppins-SemiBold.ttf");
}

.card {
  width: 75vw;
  position: inherit; /* workaround to card being displayed on top of toolbar shadow */
  /* padding-bottom: 0.5em; */
  box-shadow: none !important;
}
.card__title {
  padding: 0.5em;
  padding-top: 0.75em;
}
.card__text {
  padding: 0.33em;
}

.button-row {
  display: inline-block;
  margin-top: 3vw;
right: 10vw;
  position: relative;
}

.card__actions .btn {
  margin: 4px 4px;
  font-size: 1em;
  min-width: 44px;
}

.card__actions.button-row {
  justify-content: center;
  /* padding-bottom: 0.15em; */
  background-color: #F3F3F3;
  border-radius: 24px;
}

.buttonContainer {
  width: 85vw;
  display: flex;
  color: #999999;
  font-size: 4vw;
  margin-left: -1.5vw;
  padding-left: 1vw;
}

.secondarybtn {
  height: 12vw;
  display: flex;
  align-items: center;
}

.secondarybtn:active {
  /* color: #ff8e52 !important; */
  font-weight: 800;
  background-color: #E7E7E7 !important;
}

/deep/.btn__content {
  font-size: 4vw;
}

/deep/.btn:hover .btn__content:before {
  background-color: #fff3ed !important;
  color: #fff3ed !important;
}
</style>
